import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Event } from '@/types';

export const getUserEvents = (eventId: number): Promise<Event[]> => {
  return axios.get(`/${eventId}/event/user`);
};

type QueryFnType = typeof getUserEvents;

type UseEventsOptions = {
  eventId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useUserEvents = ({ config, eventId }: UseEventsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['userEvents', eventId],
    queryFn: () => getUserEvents(eventId),
    ...config,
  });
};
